import React from "react";
import { makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import { useParams } from "react-router-dom";
import CommandListContainer from "../containers/mobile-frame/CommandListContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const CommandListPage = () => {
  const classes = useStyles();
  let { type, eklok } = useParams();

  return (
    <Page className={classes.root} title="Command List">
      <CommandListContainer type={type} eklok={eklok} />
    </Page>
  );
};

export default CommandListPage;
